import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

import Icon from 'carbon-react/lib/components/icon';

import styles from './sync-control-reconnect-cta.scss';

interface SyncControlReconnectCtaProps {
  message?: ReactNode;
  onClick?: () => void;
  showLabel?: boolean;
}

export const SyncControlReconnectCta = ({ message, onClick, showLabel }: SyncControlReconnectCtaProps) => {
  const intl = useIntl();

  const defaultReconnectMessage = intl.formatMessage({
    id: 'common.reconnect',
    defaultMessage: 'Reconnect'
  });

  return (
    <button
      onClick={onClick}
      style={showLabel ? { padding: 4, top: '-1px' } : {}}
      aria-label={!showLabel ? defaultReconnectMessage : undefined}
      className={styles.transparentBtn}
    >
      {showLabel ? (
        <div className={clsx('uiTypeFont14Regular', styles.label, styles.textColor)}>
          {message || defaultReconnectMessage}
        </div>
      ) : (
        <>
          <div className="uiTypeNotificationBody">
            <Icon type="sync" fontSize="small" className={styles.icon} />
          </div>
        </>
      )}
    </button>
  );
};
